import React from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'next/navigation';
import { Eyebrow, SectionIntro } from '@web/atoms';
import { CtaButton } from '@web/molecules';
import { StyledSimplifiedHero, ButtonWrapper } from './styles.js';

export const SimplifiedHero = ({
  heading,
  headingVariants,
  description,
  backgroundColor = 'background.base',
  link,
  buttonVariant = 'primary',
  level,
  eyebrow,
  typography,
  fontColor = 'text.primary',
}) => {
  const searchParams = useSearchParams();
  const headingVariant = searchParams?.get('hpkeyword');

  if (headingVariant && headingVariants) {
    const variant = headingVariants.find(e => e.variant === headingVariant);
    if (variant) {
      heading = variant.heading;
    }
  }
  return (
    <StyledSimplifiedHero backgroundColor={backgroundColor}>
      {eyebrow && <Eyebrow textAlign="center">{eyebrow}</Eyebrow>}
      <SectionIntro
        fontColor={fontColor}
        headline={heading}
        subheadline={description}
        headingLevel={level}
        typography={typography}
      />
      {link && (
        <ButtonWrapper backgroundColor={backgroundColor}>
          <CtaButton
            href={link.target}
            variant={buttonVariant}
            icon={link.icon}
            iconAlignment={link.iconAlignment}
            headerText={link.headerText}
          >
            {link.text}
          </CtaButton>
        </ButtonWrapper>
      )}
    </StyledSimplifiedHero>
  );
};

SimplifiedHero.displayName = 'SimplifiedHero';

SimplifiedHero.propTypes = {
  heading: PropTypes.string.isRequired,
  headingVariants: PropTypes.array,
  description: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }),
  buttonVariant: PropTypes.string,
  level: PropTypes.string,
  eyebrow: PropTypes.string,
  typography: PropTypes.string,
  fontColor: PropTypes.string,
};
